export const removeTags = text => text ? text?.replace(/<[^>]*>?/gm, '') : '';